module.exports = __webpack_public_path__ + "img/pencil_icon.980a5e24.svg";